export const environment = {
  production: true,
  // =======================================================
  // NAME: CONSOLE PROD
  // backend: 'https://prepapi.web.continualengine.com/',

  // NETLIFY APP URL CONNECTED TO THIS ENV:
  // URL: https://console.prep.continualengine.com/
  // =======================================================


  // =======================================================
  // NAME: RSP 
  // backend: 'https://stgprp.web.moocpedia.com/',

  // NETLIFY APP URL CONNECTED TO THIS ENV:
  // URL: https://rsp-prep.netlify.app/
  // =======================================================


  // =======================================================
  // NAME: CLONE 
  // backend: 'https://clonecepoc.web.moocpedia.com/',

  // NETLIFY APP URL CONNECTED TO THIS ENV:
  // URL: https://clone-prep.netlify.app/
  // URL: https://clone-prep-v1.netlify.app/
  // =======================================================


  // =======================================================
  // NAME: EFSA 
  // backend: 'https://efsaweb.continualengine.com/',

  // NETLIFY APP URL CONNECTED TO THIS ENV:
  // URL: https://efsa-prep.netlify.app/
  // =======================================================


  // =======================================================
  // NAME: ELPASO
  // backend: 'https://clsprweb.continualengine.com/',

  // NETLIFY APP URL CONNECTED TO THIS ENV:
  // URL: https://elpaso.prep.continualengine.com/
  // =======================================================


  // =======================================================
  // NAME: COLORADO SRINGS
  // backend: 'https://epprweb.continualengine.com/',

  // NETLIFY APP URL CONNECTED TO THIS ENV:
  // URL: https://coloradosprings.prep.continualengine.com/
  // =======================================================


  // =======================================================
  // NAME: COLORADO MOUNTAIN 
  // backend: 'https://efsaweb.continualengine.com/',

  // NETLIFY APP URL CONNECTED TO THIS ENV:
  // URL: https://coloradomountain.prep.continualengine.com/
  // =======================================================



  // =======================================================
  // NAME: STANFORD UNV
  backend: 'https://efsaweb.continualengine.com/',

  // NETLIFY APP URL CONNECTED TO THIS ENV:
  // URL: https://stanford.efsaprep.continualengine.com/
  // ============


  // =======================================================
  // NAME: DEMO CLIENT
  // backend: 'https://demoprep.web.moocpedia.com/',

  // NETLIFY APP URL CONNECTED TO THIS ENV:
  // URL: https://demo-prep.netlify.app/
  // =======================================================


  // XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX
  // NAME: STAGE OLD [XXXXXXXXX DEPRECATED XXXXXXXXXXX]
  // backend: 'https://prt3.web.moocpedia.com/',

  // NETLIFY APP URL CONNECTED TO THIS ENV:
  // URL: https://stage-prep.netlify.app/
  // XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX


  // =======================================================
  // NAME: STAGE
  // backend: 'https://stgusbe.web.moocpedia.com/',

  // NETLIFY APP URL CONNECTED TO THIS ENV:
  // URL: https://newstaging-prep.netlify.app/˝
  // =======================================================

};